import React, { ReactNode } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

export type CenterLayoutProps = {
    children?: ReactNode;
    className?: string;
};

function CenterLayout(props: CenterLayoutProps): React.JSX.Element {
    const { className } = props;

    return <div className={cn(className, 'container mx-auto')}>{props.children}</div>;
}

export default CenterLayout;
